import { Outlet } from 'react-router-dom';
import { UserContextProvider } from '@/shared/providers/user-context';
import { SidebarProvider } from '@/shared/ui/sidebar';
import { MainSidebarClient } from '@/widgets/layout/main-sidebar-client';

export function MainLayout() {
  return (
    <UserContextProvider>
      <SidebarProvider>
        <div className="flex h-screen overflow-hidden bg-background w-full">
          <MainSidebarClient />
          <main className="flex-1 flex flex-col overflow-hidden relative w-full bg-sidebar p-3">
            <div className="flex-1 overflow-hidden h-full rounded-t-lg bg-neutral-50 drop-shadow">
              <Outlet />
            </div>
          </main>
        </div>
      </SidebarProvider>
    </UserContextProvider>
  );
}
